import { toRound } from '../../helpers/Format';
import React from 'react';
import { TypeDiscount } from '../../modules/DiscountReasons/Model';
export var Discount = function (_a) {
    var item = _a.item;
    if (item.totalDiscount) { // nueva implementación, descuento fijo o por porcentaje
        return React.createElement("div", null,
            React.createElement("p", { style: { margin: '0', padding: 0, textDecoration: 'line-through', fontWeight: 'normal', textAlign: 'end' } }, "Total  ".concat(toRound(Math.abs(item.total) + item.totalDiscount), " ").concat(item.money)),
            React.createElement("p", { style: { margin: '0', padding: 0, textAlign: 'end' } }, item.typeDiscount === TypeDiscount.Percentage
                ? "".concat(item.discount, "% descuento: -").concat(toRound(item.totalDiscount), " ").concat(item.money)
                : "Descuento: ".concat(toRound(item.discount), " ").concat(item.money)));
    }
    // antigua implementación, el tipo de descuento era fijo (dinero)
    return React.createElement("div", null,
        React.createElement("p", { style: { margin: '0',
                padding: 0,
                textDecoration: 'line-through',
                fontWeight: 'normal',
                textAlign: 'end' } }, "Total  ".concat(toRound(Math.abs(item.total) + item.discount), " ").concat(item.money)),
        React.createElement("p", { style: { margin: '0', padding: 0, textAlign: 'end' } }, "Descuento: ".concat(toRound(item.discount), " ").concat(item.money)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Discount.tsx
// module id = 1156
// module chunks = 0